module.exports = __webpack_public_path__ + "img/blue.be5030ca.webp";